export default "__VITE_ASSET__BpG1yneX__"